import Vue from 'Vue'
export const COUNTSTR = 'inputNumber'
// 正式环境
export const WEBSOCKETLOC = 'ws://39.108.4.123:8080/sale/order/main.do'
// export const WEBSOCKETLOC = 'ws://39.108.4.123:8089/sale/order/main.do'
export var vm = new Vue()



// WEBPACK FOOTER //
// ./src/common/js/vm.js